export default __webpack_public_path__ + "static/media/location.3204ea9a.svg";